


































import { Component, Vue } from 'vue-property-decorator';
import StarIcon from 'vue-material-design-icons/Star.vue';
import Optionals from '@/plugins/api/Optionals';

@Component({
  components: { StarIcon },
})
export default class DetalhesTerceiros extends Vue {
  public image = require('@/assets/images/crashed-car.svg');
  public coberturas: Array<{ label: string; value: number; sqid: string; index: number }> = [];

  public async mounted() {
    const data = await Optionals.get();
    this.coberturas = data.items.map((item, index) => ({
      label: item.label,
      value: parseFloat(item.value),
      sqid: item.sqid,
      index,
    }));
  }

  get cobertura() {
    return this.$store.state.cotacao.valor_cobertura;
  }

  set cobertura(value) {
    const data = this.coberturas.find((item) => item.value === value);
    if (data !== undefined) {
      this.$store.direct.dispatch.ATUALIZAR_COBERTURA(data);
    }
  }
}
